import type { ThreadFilters } from '~/components/message-hub/messageHubUtil';

export type IntelligentInboxThreadFilters = ThreadFilters & {
    lifecycle_status: string;
    membership_status: string;
};

export const defaultIntelligentInboxFilters = (): IntelligentInboxThreadFilters => ({
    search: '',
    tag: '',
    group_id: '',
    lifecycle_status: '',
    membership_status: '',
});
